import i18n from '../../locales/index'
import { genBasicStore } from '../vuex'

const store = genBasicStore('mall_group')

export default store;
